import { parse } from 'hub-http/helpers/params';
import { getRouteParams } from '../routing/getRouteParams';
import { isPreVerification } from '../flow-settings/settingsSelectors';
import PortalIdContainer from '../portal-id-container/PortalIdContainer';
import { getQueryParams } from '../routing/getQueryParams';
import { getHublet } from '../store/app/selectors';
import { updateAuth } from '../store/auth/action-creators';
import UsageTrackerContainer from '../tracking/UsageTrackingContainer';
import checkAuth from './checkAuthApi';

const setAuthHubless = auth => dispatch => {
  const userId = auth.id;
  const email = auth.email;
  const user = {
    firstName: auth.firstName,
    lastName: auth.lastName,
    email
  };
  dispatch(updateAuth({
    auth,
    user,
    gates: [],
    portal: {},
    portalId: null,
    userId,
    initialized: true
  })); // When a user is properly authed, re-initialize tracker
  //do not set the hstc again, as it will wait indefinitely for the cookie
  //at this point we don't need it as we have the email and user id as identifiers

  const updatedUsageTrackerConfig = {
    namespace: 'signup',
    email,
    userId
  };
  const queryParams = getQueryParams();

  if (isPreVerification() || email.toLowerCase() === queryParams['email'].toLowerCase()) {
    UsageTrackerContainer.setProperties(updatedUsageTrackerConfig);
  }

  return Promise.resolve({
    email
  });
};

const setAuth = auth => dispatch => {
  const portalId = PortalIdContainer.get() || auth.hubIds[0];
  const user = {
    firstName: auth.firstName,
    lastName: auth.lastName,
    email: auth.email
  };
  dispatch(updateAuth({
    auth,
    user,
    portalId,
    userId: auth.id,
    initialized: true
  })); // When a user is properly authed, re-initialize tracker
  //do not set the hstc again, as it will wait indefinitely for the cookie
  //at this point we don't need it as we have the email and user id as identifiers

  const queryParams = getQueryParams();

  if (isPreVerification() || auth.email.toLowerCase() === queryParams['email'].toLowerCase()) {
    UsageTrackerContainer.setProperties({
      namespace: 'signup',
      email: auth.email,
      hubId: portalId,
      userId: auth.id
    });
  }

  return Promise.resolve({
    email: auth.email
  });
};

const init = () => (dispatch, getState) => {
  const state = getState();
  const hublet = getHublet(state);
  return checkAuth(hublet).then(auth => {
    const {
      hubIds = []
    } = auth;

    if (hubIds.length) {
      PortalIdContainer.set(PortalIdContainer.get() || hubIds[0]);
      dispatch(setAuth(auth));
    } else {
      dispatch(setAuthHubless(auth));
    }

    return auth;
  });
};

export const Auth = {
  init
};
export const getGatesWithUrlOverrides = gates => {
  const {
    gates: overrideGates
  } = parse(getRouteParams().search);

  if (!overrideGates) {
    return gates;
  }

  if (!Array.isArray(overrideGates)) {
    return [...gates, overrideGates];
  }

  return [...gates, ...overrideGates];
};